import { connect } from 'react-redux';
import { CustomQuestionsModal } from '../../../components/questions/custom-questions/CustomQuestionsModal';
import { IApplicationState } from '../../../store';
import { ActionCreators as CustomQuestionModalActionCreators } from '../../../store/CustomQuestionModalStore';
import { ActionCreators as CustomQuestionsActionCreators } from '../../../store/CustomQuestionStore';
import { ActionCreators as QuestionsActionCreators } from '../../../store/QuestionModalStore';

export const CustomQuestionsModalContainer: React.ComponentType<any> = connect(
	(state: IApplicationState) => ({
		...state.customQuestion,
		...state.customQuestionsModal,
		addedQuestions: state.questionModal.addedQuestions,
		selectedQuestionVariationIds: state.questionModal.selectedQuestionVariationIds,
		selectedCustomQuestionIds: state.questionModal.selectedCustomQuestionIds,
	}),
	{
		...QuestionsActionCreators,
		...CustomQuestionsActionCreators,
		...CustomQuestionModalActionCreators,
	},
)(CustomQuestionsModal);
